export default "__VITE_ASSET__BJiYxL5p__"